export default class FileModel {
  constructor (data) {
    this.values = {
      id: null,
      contents: null
    }

    window.PRIM.modelMapper.mapToModel(data, this.values)
  }

  getTitle () {
    return this.values.id
  }
  getSubtitle () {
    return this.values.contents.length
  }
  getImage () {
    return null
  }
  getIndex () {
    if (this.getCompareString()) {
      return this.getCompareString().substring(0, 1).toUpperCase()
    }

    return null
  }
  getCompareString () {
    return this.values.id
  }

  getJSON () {
    let result = {}

    window.PRIM.modelMapper.mapToObject(this.values, result)

    return result
  }
}



// WEBPACK FOOTER //
// ./js/modules/file/model/FileModel.js